export const Gender: React.FC<any> = props => (
	<svg
		data-testid="gender-icon"
		width="14"
		height="19"
		viewBox="0 0 14 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M3.57143 16.3H7M5.28571 12.9V18M5.28571 12.9C7.65265 12.9 9.57143 10.9972 9.57143 8.65C9.57143 6.30279 7.65265 4.4 5.28571 4.4C2.91878 4.4 1 6.30279 1 8.65C1 10.9972 2.91878 12.9 5.28571 12.9ZM9.57143 1H13M13 1V4.4M13 1L8.32003 5.641"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
